import { Form } from 'react-bootstrap';
import React, { KeyboardEvent } from 'react';
import { Field, FieldProps } from 'formik';
import classnames from 'classnames';
import { FieldErrorMessage } from '../field-error-message/field-error-message';
import styles from './text-field.module.scss';

export type TextFieldProps = {
  label: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  onKeyUp?: (event: KeyboardEvent) => void;
  readOnly?: boolean;
  autoFocus?: boolean;
};

export function TextField({
  name,
  label,
  placeholder,
  disabled,
  onKeyUp,
  readOnly = false,
  autoFocus = true,
}: TextFieldProps) {
  return (
    <Field name={name}>
      {({ field, meta }: FieldProps<string>) => (
        <Form.Group controlId={name}>
          <Form.Label className={styles['label']}>{label}</Form.Label>
          <Form.Control
            autoFocus={autoFocus}
            type="text"
            placeholder={placeholder}
            disabled={disabled}
            {...field}
            onKeyUp={onKeyUp}
            readOnly={readOnly}
            className={classnames(styles['input'], {
              [styles['readonly']]: readOnly,
            })}
          />
          <FieldErrorMessage meta={meta} />
        </Form.Group>
      )}
    </Field>
  );
}

export default TextField;
